<template>
    <nav id="nav-container">
        <div id="top-bar">
            <span class="main-phone-number">Tel: +504 2440-5298</span>
            <span class="separator">|</span>
            <div id="social-links">
                <a href="https://www.facebook.com/hotellashamacas/" target="_blank">
                    <img src="../assets/images/icons/facebook-scaled.png" alt="Facebook Logo">
                </a>
                <a href="https://www.instagram.com/hotellashamacas/" target="_blank">
                    <img src="../assets/images/icons/insta-scaled.png" alt="Instagram Logo">
                </a>
            </div>
            <span class="separator">|</span>
            <div id="language-chooser">
                <a @click.prevent="$store.commit('changeLang','en')" href="#">
                    <img src="../assets/images/icons/usa-flag.png" alt="English">
                </a>
                <a @click.prevent="$store.commit('changeLang','es')" href="#">
                    <img src="../assets/images/icons/spain-flag.png" alt="Español">
                </a>
            </div>
        </div>
        <div id="small-nav">
            <img src="../assets/images/icons/icons8-menu.svg" alt="Menu" class="menu"
                 @click="toggleSmallMenu">
            <router-link :to="{name: 'home'}">
                <img src="../assets/images/icons/logo-hotel-transparent-scaled.png"
                     alt="Small Menu Logo"
                     class="small-logo">
            </router-link>
            <!--<button class="reserve" @click="$router.push({name: 'availability'})">Reservar</button>-->
        </div>
        <div id="normal-nav" :class="{'show-small-menu' : isSmallMenuVisible}">
            <router-link :to="{name: 'home'}" class="nav-logo">
                <img src="../assets/images/icons/logo-hotel-transparent-scaled.png"
                     alt="Hotel Logo">
            </router-link>
            <ul class="nav-items">
                <router-link tag="li" @click="isSmallMenuVisible=false" :to="{name: 'rooms'}">
                    <a>Habitaciones</a>
                </router-link>
                <router-link tag="li" @click="isSmallMenuVisible=false" :to="{name: 'packages'}">
                    <a>Paquetes</a>
                </router-link>
                <router-link tag="li" @click="isSmallMenuVisible=false" :to="{name: 'facilities'}">
                    <a>Instalaciones</a>
                </router-link>
                <router-link tag="li" @click="isSmallMenuVisible=false" :to="{name: 'contact'}">
                    <a>Contacto y Dirección</a>
                </router-link>
                <router-link tag="li" @click="isSmallMenuVisible=false" :to="{name: 'about'}">
                    <a>Quienes Somos</a>
                </router-link>
                <router-link tag="li" @click="isSmallMenuVisible=false" :to="{name: 'menu'}">
                    <a>Menú</a>
                </router-link>
            </ul>
            <!--<button class="reserve" @click="$router.push({name: 'availability'})">Reservar</button>-->
        </div>
    </nav>
</template>

<script>
export default {
    name: 'MainMenu',
    data() {
        return {
            isSmallMenuVisible: false,
            isReservationDialogOpen: false
        }
    },
    methods: {
        toggleSmallMenu() {
            this.isSmallMenuVisible = !this.isSmallMenuVisible
        }
    }
}
</script>

<style scoped>
    #nav-container {
        background-color: #FFF;
        position: fixed;
        z-index: 10;
        top: 0;
        width: 100%;
        max-width: 1440px;
        /*border-top: 5px solid #643229;*/
        border-bottom: 1px solid #643229;
    }

    #top-bar {
        height: 25px;
        background-color: #643229;
        display: flex;
        justify-content: end;
        align-items: center;
    }

    #top-bar .main-phone-number {
        color: #FFF;
        font-weight: 500;
    }

    #top-bar .separator {
        font-weight: 600;
        color: #FFF;
        margin: 0 20px;
    }

    #social-links {
        display: flex;
        align-items: center;
    }

    #social-links a {
        height: 100%;
        margin-right: 7px;
    }

    #social-links a:last-child {
        margin: 0;
    }

    #social-links a img {
        height: 23px;
        vertical-align: middle;
    }

    #language-chooser a {
        height: 100%;
        margin-right: 7px;
    }

    #language-chooser a img {
        vertical-align: middle;
    }

    #small-nav {
        display: none;
    }

    #normal-nav {
        display: flex;
        align-items: stretch;
        justify-content: space-evenly;
        overflow: hidden;
        height: 75px;
        font-size: 0.95rem;

    }

    #normal-nav .reserve {
        background-color: #643229;
        border-radius: 5px;
        color: #F1DDC4;
        font-size: 1rem;
        font-weight: 400;
        align-self: center;
        padding: 15px;
        margin: 5px 0;
    }

    #normal-nav .nav-logo {
        height: 100%;
        padding: 0;
    }

    #normal-nav .nav-logo img {
        height: 100%;
    }

    #normal-nav .nav-items {
        display: flex;
        padding: 0;
        margin: 0;
        font-weight: 500;
        list-style-type: none;
        justify-content: center;
    }

    #normal-nav .nav-items li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        transition: all .2s;
    }

    #normal-nav .nav-items li:hover {
        background-color: #643229;
    }

    #normal-nav .nav-items li:hover a {
        color: #F1DDC4;
    }

    #normal-nav .nav-items li:active {
        background-color: #643229;
    }

    #normal-nav .nav-items li:active a {
        color: #F1DDC4;
    }

    #normal-nav .nav-items .active {
        background-color: #643229;
    }

    #normal-nav .nav-items .active a {
        color: #F1DDC4;
    }

    #normal-nav .nav-items a {
        text-decoration: none;
        color: #643229;
        padding: 10px;
        border-bottom: 2px solid transparent;
        transition: all .2s;
    }

    @media only screen and (min-width: 320px) and (max-width: 767px) {
        #nav-container {
            border-top: 3px solid #643229;
        }

        #normal-nav {
            flex-direction: column;
            display: none;
            height: auto;
        }

        #normal-nav .reserve {
            display: none;
        }

        #normal-nav .nav-logo {
            display: none;
        }

        #normal-nav .nav-items {
            flex-direction: column;
        }

        #small-nav {
            height: auto;
            width: 100%;
            display: flex;
            padding: 5px 15px;
            justify-content: space-between;
            box-sizing: border-box;
            align-items: center;
        }

        #small-nav .menu {
            width: 30px;
            height: 30px;
        }

        #small-nav .small-logo {
            height: 53px;
        }

        #small-nav .reserve {
            background-color: #643229;
            border-radius: 5px;
            color: #F1DDC4;
            font-size: 1rem;
            font-weight: 400;
            align-self: stretch;
            padding: 1px 5px 2px;
            margin: 5px 0;
        }

        .show-small-menu {
            display: flex !important;
        }
    }
</style>
